<template>
  <section v-if="completeLoadingTarget && !onBoarding.loading">
    <h6 class="mt-4">{{ $t("lang.orders.jobtitle") }}</h6>
      <KeyWordSearch
        :taglimit="99"
        :multipleValuesAtOnce="true"
        :isDisabled="isDisabled || selectDisable"
        ref="jobtilte"
        :default_values="onBoarding.target.categories_jobs"
        @change="changeKeywords($event)"
      />
    <template v-if="!hasPermissions('billing')">
      <h6 class="mt-2">{{ $t("lang.onBoarding.step2_1_question") }}</h6>
      <IndustrySearch
        :option_list="
          this.$store.state.optionsList.all.categories_search_level.data
        "
        @closed="changeSomething()"
        :default_values="onBoarding.target.positions"
        :isDisabled="isDisabled || selectDisable"
        :fromOrder="true"
      >
      </IndustrySearch>
      <h6 class="mt-4">{{ $t("lang.onBoarding.step2_2_question") }}</h6>
      <IndustrySearch
        :option_list="
          this.$store.state.optionsList.all.categories_search_function.data
        "
        :default_values="onBoarding.target.departments"
        :isDisabled="isDisabled || selectDisable"
        :fromOrder="true"
        @closed="changeSomething()"
      >
      </IndustrySearch>
    </template>
    <h6 class="mt-4">{{ $t("lang.onBoarding.step2_4_question") }}</h6>
    <p class="mt-2">{{ $t("lang.onBoarding.include") }}</p>
    <IndustrySearch
      :option_list="
        this.$store.state.optionsList.all.categories_google_all.data
      "
      :default_values="onBoarding.target.sectors_include"
      :isDisabled="isDisabled || selectDisable"
      :fromOrder="true"
      :openDirection="'top'"
      @closed="changeSomething()"
    >
    </IndustrySearch>
    <p class="mt-2">{{ $t("lang.onBoarding.exclude") }}</p>
    <IndustrySearch
      :option_list="
        this.$store.state.optionsList.all.categories_google_all.data
      "
      :default_values="onBoarding.target.sectors_exclude"
      :isDisabled="isDisabled || selectDisable"
      :fromOrder="true"
      :openDirection="'top'"
      @closed="changeSomething()"
    >
    </IndustrySearch>

    <h6 class="mt-4">{{ $t("lang.onBoarding.step2_3_question") }}</h6>

    <IndustrySearch
      :option_list="select_list_sizes"
      :default_values="onBoarding.target.sizes"
      :isDisabled="isDisabled || selectDisable"
      :fromOrder="true"
      @closed="changeSomething()"
    >
    </IndustrySearch>


    <h6 class="mt-4">{{ $t("lang.onBoarding.step2_5_question_1") }}</h6>
    <IndustrySearch
      class="mb-4"
      :option_list="this.$store.state.optionsList.all['countries'].data"
      :default_values="onBoarding.target.contact_country"
      :isDisabled="isDisabled || selectDisable"
      :openDirection="'top'"
      :fromOrder="true"
      @closed="changeSomething()"
    >
    </IndustrySearch>
    <h6 class="mt-4">{{ $t("lang.onBoarding.step2_5_question_2") }}</h6>
    <IndustrySearch
      :option_list="this.$store.state.optionsList.all['regions'].data"
      :default_values="onBoarding.target.company_location"
      :isDisabled="isDisabled || selectDisable"
      :fromOrder="true"
      @closed="changeSomething()"
    >
    </IndustrySearch>






  </section>
</template>

<script>
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import { targetsService } from "@/_services";
import { mapState, mapActions } from "vuex";
import KeyWordSearch from "@/components/AccountCreation/Steps/Campaign/search/KeyWordSearch.vue";


export default {

  props: {
    selectDisable: {
          type: Boolean,
          required: false,
          default: () => true,
        },
    poupView: {
          type: Boolean,
          required: false,
          default: () => false,
        },
  },

  data() {
    return {
      size: {
        greater: 0,
        less: 0,
      },
       keywordscant: 0,
      addSelect: false,
      apollo: {
        total_result: 0,
        people: [],
      },
      data: {
        categories_industry: [],
        categories_not_industry: [],
        employees: {
          keywords: {
            greater: 0,
            less: 0,
          },
        },
        categories_level: [],
        categories_function: [],
        categories_jobs: {},
        region: [],
        countries: [],
      },
      select_list_sizes: [
        { id: 0, label: "1-10" },
        { id: 1, label: "11-20" },
        { id: 2, label: "21-50" },
        { id: 3, label: "51-100" },
        { id: 4, label: "101-200" },
        { id: 5, label: "201-500" },
        { id: 6, label: "501-1000" },
        { id: 7, label: "1001-2000" },
        { id: 8, label: "2001-5000" },
        { id: 9, label: "5001-10000" },
        { id: 10, label: "10001+" },
      ],
      selected_sizes: [],
    };
  },


  components: {
    IndustrySearch,
    KeyWordSearch,
  },
  computed: {
    ...mapState({
      completeLoadingTarget: (state) => state.optionsList.completeLoadingTarget,
      onBoarding: (state) => state.onboarding,
      isDisabled: (state) => state.onboarding.isDisable,
    }),
  },
  created() {
    if(!this.onBoarding.completeLoadingTarget){
      this.$store.dispatch("optionsList/getAllTargetParams");
    }
    this.selected_sizes = this.onBoarding.target.sizes;
    this.addSelect=true;
    if(this.poupView){
      this.getApollo()
    }
  },

  methods: {
    ...mapActions("onboarding", {
      getApollo: "getApollo",
      updateCategoryJobs:"updateCategoryJobs",
      calculateSize : "calculateSize"
    }),
    hasPermissions(perm){
      return this.$store.getters['authentication/hasPermissions'](perm)
    },
    changeKeywords(e){
      this.updateCategoryJobs(e)
      this.changeSomething()
    },
    changeSomething(){
      if(this.poupView){
        this.getApollo()
      }else{
        this.calculateSize();
        this.$emit("save")
      }
    }


  },
};
</script>
